export default "__VITE_ASSET__DdO85oFV__"